import { get, writable } from "svelte/store";
import LoadState from "../../Enums/LoadState";
import BaseModel from "../../Models/BaseModel";
import MARMANsStore from "./Store";

const MARMANDataMapping = {
	name: "properties.objnam",
	category: "properties.catmma",
	country: "properties.nation",
	ukhoId: "properties.identy",
	esriId: "properties.FID"
};
class MARMAN extends BaseModel {
	constructor(feature) {
		super(MARMANDataMapping, {
			name: "Unknown",
			category: "N/A",
			country: "Unknown",
			ukhoId: "",
			esriId: ""
		});

		this.data = feature;

		this.loadState = writable(LoadState.INIT);
		this.visible = writable(false);

		this.visible.subscribe((visible) => {
			if (visible && get(this.loadState) === LoadState.INIT) {
				MARMANsStore.actions.loadSingle(this);
			}
			// else if (!visible && get(this.loadState) === LoadState.LOADED) {
			// 	MaritimeBoundariesStore.actions.updateFeatureCollection();
			// }
		});
	}

	get name() {
		return this.get("name");
	}

	get category() {
		return this.get("category");
	}

	get country() {
		return this.get("country");
	}

	get esriId() {
		return this.get("esriId");
	}

	get uniqId() {
		return "marman_" + this.esriId;
	}

	asFeature() {
		return this.data;
	}
}

export default MARMAN;
